import { FaSignature } from "react-icons/fa";
import styled from "styled-components";

const Styles = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  max-height: 42px;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  padding: 0 10px;
  color: #8c8c8c;
  gap: 8px;
  font-size: 13px;
`;

const EmployeeSignature = () => {
  return (
    <Styles>
      <FaSignature size={16} />
      <span>(社員署名プレビュー)</span>
    </Styles>
  );
};

export default EmployeeSignature;
